<mat-toolbar class="bottom" color="primary">
	<button mat-icon-button (click)="previousPageService.goToPreviousUrl()" class="sidenavToggleButton">
		<mat-icon>arrow_back</mat-icon>
	</button>
	<span fxFlex></span>
	<button mat-icon-button (click)="previousPageService.goTo('/')" class="sidenavToggleButton right">
		<mat-icon class="avatar">home</mat-icon>
	</button>
</mat-toolbar>
